import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../utils/cn';

type CheckboxProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

export function Checkbox({ label, checked, onChange, className }: CheckboxProps) {
  return (
    <label className={cn('flex items-center gap-3 cursor-pointer group', className)}>
      <div 
        className={cn(
          'w-6 h-6 rounded border-2 flex items-center justify-center transition-colors duration-200',
          checked ? 'bg-[#236caf] border-[#236caf]' : 'border-gray-300 group-hover:border-[#236caf]'
        )}
        onClick={() => onChange(!checked)}
      >
        {checked && <Check className="w-4 h-4 text-white" />}
      </div>
      <span className="text-gray-700">{label}</span>
    </label>
  );
}